import { parseISO } from 'date-fns';

import { isValidStay } from './stay';
import { getSuggestions } from './suggestions';
import { validAvailabilityRules } from './availability-rules';
import { validateShortTermPenalty } from './min-stay-penalty';
import { getAvailableFrom } from '@spa/shared/utils/transformers/contracts';

export const getProps = offer => {
  const {
    contract: {
      type: contractType,
      standard: { rents, penalty }
    },
    availabilities: { availability_rules: availabilityRules = [] },
    requisites: {
      conditions: { minimum_nights: conditionsMinimumNights }
    }
  } = offer;

  const minimumStay =
    Math.max(conditionsMinimumNights || 0, availabilityRules[0]?.gap?.move_in_out?.items?.[0]?.end?.min?.days || 0) ??
    null;
  const maximumStay = availabilityRules[0]?.gap?.move_in_out?.items?.[0]?.end?.max?.days ?? null;
  const availableFrom = getAvailableFrom(offer);

  return { availabilityRules, availableFrom, contractType, penalty, rents, minimumStay, maximumStay };
};

export const isRangeValid = (start = null, end = null, t, language, offer) => {
  const startDate = start && parseISO(start);
  const endDate = end && parseISO(end);

  const { availabilityRules, availableFrom, contractType, minimumStay, maximumStay, penalty, rents } = getProps(offer);

  const rules = validAvailabilityRules(t, language, availabilityRules, availableFrom, startDate, endDate);
  const minStayWarning = validateShortTermPenalty(t, language, startDate, endDate, penalty);
  const validStayError = isValidStay(startDate, endDate, minimumStay, maximumStay, t, language);

  const [validation = null] = [rules, validStayError].filter(({ isValid }) => !isValid);
  const [warning = {}] = [minStayWarning].filter(({ warning }) => warning);

  const suggestions = getSuggestions(
    start,
    end,
    t,
    language,
    rents,
    contractType,
    availabilityRules,
    availableFrom,
    minimumStay,
    maximumStay
  );

  return { ...warning, ...(validation ?? { ...rules, ...validStayError }), suggestions };
};
